export class Parametro {

    nome: string;
    valor: string;

    constructor(nome: string, valor: string) {
        this.nome = nome;
        this.valor = valor;
    }

}
